import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { Layout, Menu, MenuProps } from "antd";
import { ConnectedProps } from "react-redux";

import { sidebarMenuItems, roleAccess, selectedItem } from "../../utils";
import connector from "./Container";
import styles from "./Sidebar.module.scss";

const { Sider } = Layout;

const Sidebar = ({ state }: ConnectedProps<typeof connector>) => {
  const { user } = state;
  const navigate = useNavigate();
  const location = useLocation();
  const [selected, setSelected] = useState<string>(location.pathname);
  const [menuItems, setMenuItems] = useState<MenuProps["items"]>([]);

  useEffect(() => {
    const accessibleItems =
      sidebarMenuItems && user
        ? sidebarMenuItems.filter(
            (item) =>
              item &&
              item.key &&
              roleAccess[user.role]?.includes(item.key.toString())
          )
        : [];
    setMenuItems(accessibleItems);
  }, [user]);

  useEffect(() => {
    setSelected(selectedItem());
  }, [location.pathname]);

  return (
    <Sider
      breakpoint="lg"
      collapsedWidth="60"
      className="bg-white"
      width={"208px"}
    >
      <Menu
        onClick={(item) => navigate(item.key)}
        selectedKeys={[selected]}
        className={`${styles.item} ${styles.selected} mt-8 bg-white border-r-0`}
        mode="inline"
        items={menuItems}
      />
    </Sider>
  );
};

export default Sidebar;
